<template>
  <HeaderComponent :key="loginUpdate"/>
  <AdminHeaderComponent :key="loginUpdate" @view-email-changed="viewEmailChanged"/>
  <div class="major-wrapper page container-page padding-xs-v-2 padding-lg-v-3">
    <router-view :key="viewEmailUpdate" @login-changed="loginChanged"></router-view>
  </div>
  <footer>
    <FooterComponent :key="loginUpdate"/>
  </footer>
  <sdx-dialog
      id="cookie-modal"
      label="Cookies consent"
      icon-name="icon-cookie"

  >
    <sdx-dialog-content>
      <p>We use cookies and analysis tools to improve the user experience.</p>
      <sdx-button-group>
        <sdx-button label="Close information" @click="closeCookieNotificationOk()"></sdx-button>
      </sdx-button-group>
    </sdx-dialog-content>
  </sdx-dialog>
</template>

<script>
import {defineComponent} from 'vue';
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent.vue';
import AdminHeaderComponent from '@/components/AdminHeaderComponent.vue';
import {logger} from "@/services/logger.service";
import axios from "axios";


export default defineComponent({
  name: 'App',
  components: {
    FooterComponent,
    HeaderComponent,
    AdminHeaderComponent,
  },
  data: function () {
    return {
      //flag for changing components if event-update-header was raised
      loginUpdate: 0,
      viewEmailUpdate: "",
      cookieNotification: undefined
    }
  },
  created() {
    axios.interceptors.request.use((config) => {
      // trigger 'loading=true' event here
      return config;
    }, (error) => {
      // trigger 'loading=false' event here
      logger.error("Axios request error: " + error);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      // trigger 'loading=false' event here
      return response;
    }, (error) => {
      // trigger 'loading=false' event here
      logger.error("Axios response error: " + error);
      return Promise.reject(error);
    });
  },
  mounted() {
    if (localStorage.getItem('cookieAccepted') !== "true") {
      this.showCookieNotification()
    }
  },
  methods: {
    viewEmailChanged(newViewEmail) {
      this.viewEmailUpdate = newViewEmail;
      logger.debug("newViewEmail:" + this.viewEmailUpdate);
    },
    loginChanged() {
      this.loginUpdate++;
      logger.debug("update:" + this.loginUpdate);
    },
    showCookieNotification() {
      document.getElementById("cookie-modal").open()
    },
    closeCookieNotificationOk() {
      localStorage.setItem('cookieAccepted', true)
      document.getElementById("cookie-modal").close()
    }

  }
});
</script>

<style>


</style>
